import { render } from "./apply.vue?vue&type=template&id=71f284d3"
import script from "./apply.vue?vue&type=script&lang=js"
export * from "./apply.vue?vue&type=script&lang=js"

import "./apply.vue?vue&type=style&index=0&id=71f284d3&lang=scss"
import "./apply.vue?vue&type=style&index=1&id=71f284d3&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__